type Options = {
    domain?: string
}

export default ({domain = ''}: Options = {}) => ({
    socialMediaLinks: [
        { title: 'facebook', href: 'https://www.facebook.com/pulsdotcom/', target: '_blank' },
        { title: 'x-twitter', href: 'https://twitter.com/pulscom', target: '_blank' },
        { title: 'youtube', href: 'https://www.youtube.com/channel/UCpXjcgaFLHsfrYSSFoi0vLw', target: '_blank' },
        {
            title: 'google', 
            href: 'https://www.google.com/maps/place/Puls/@37.5368587,-122.2421469,9z/data=!4m5!3m4!1s0x0:0x80400c01195d87c6!8m2!3d37.5368587!4d-122.2421469?hl=en',
            target: '_blank'
        },
        { title: 'instagram', href: 'https://www.instagram.com/pulscom/', target: '_blank' }
    ],
    copyright: {
        warn: 'Puls Technologies Inc. is not in any way associated with Puls GmbH of Munchen',
        copy: '\u00A9 Puls Technologies Inc ' + new Date().getFullYear()
    },
    consumerAppLinks: [
        {
            title: 'ios',
            href: "https://apps.apple.com/us/app/id1530724750"
        },
        {
            title: 'android',
            href: "https://play.google.com/store/apps/details?id=com.puls.consumers"
        }
    ],
    navLinks: [
		{
			title: 'Company',
			items: [
				{ title: 'About Us', href: `${domain}/about`},
				{ title: 'How It Works', href: `${domain}/how-it-works`, target: '' },
				{ title: 'FAQ', href: `${domain}/faq`, target: '' },
				{ title: 'Become a Tech', href: `${domain}/join`, target: '' },
				{ title: 'Pricing', href: `${domain}/pricing`, target: '' },
				{ title: 'Careers', href: `${domain}/careers`, target: '' },
				{ title: 'Info Hub', href: 'https://blog.puls.com', target: '' },
				{ title: 'Newsroom', href: `${domain}/press`, target: '' },
				{ title: 'Media inquiries', href: 'mailto:media@puls.com', target: '' },
				{ title: 'Home', href: `${domain}/`, target: '' }
			]
		},
		{
			title: 'Resources',
			items: [
				{ title: 'TV Mounting', href: 'https://info.puls.com/resources/tv-mounting' },
				{ title: 'Garage Doors', href: 'https://info.puls.com/resources/garage-doors' },
				{ title: 'Appliances', href: 'https://info.puls.com/resources/appliances' },
				{ title: 'Refrigerators', href: 'https://info.puls.com/resources/refrigerator' },
				{ title: 'Dishwashers', href: 'https://info.puls.com/resources/dishwasher' },
				{ title: 'Ovens & Stoves', href: 'https://info.puls.com/resources/oven-and-stove' },
				{ title: 'Washing Machines', href: 'https://info.puls.com/resources/washing-machine' },
				{ title: 'Dryers', href: 'https://info.puls.com/resources/dryer' }
			]
		},
		{
			title: 'Partnerships',
			items: [
				{ title: 'Puls for business', href: `${domain}/business` },
				{ title: 'Real estate agents', href: `${domain}/lp/real-estate-portal` }
			]
		},
		{
			title: 'Legals',
			items: [
				{ title: 'Privacy', href: `${domain}/privacy-policy`, target: '' },
				{ title: 'General Terms', href: `${domain}/terms`, target: '' },
				{ title: 'Member Terms', href: `${domain}/membership-terms-and-conditions`, target: '' },
				{ title: 'Member FAQ’s', href: `${domain}/lp/membership-faq`, target: '' },
				{ title: 'Technician Terms', href: `${domain}/lp/tech-app/membership-terms`, target: '' },
				{ title: 'Guarantee', href: `${domain}/guarantee`, target: '' },
                { title: "Don't Sell My Information", href: `${domain}/lp/dont-sell-info`, target: '' }
			]
		}
	],
    stayInTouch: { 
        email: 'support@puls.com',
        formTitle: 'Stay Connected'
    }
})

export const hdmNavlinks = [
    {
        title: 'Company',
        items: [
            { title: 'About Us', url: '/about' },
            { title: 'How It Works', url: '/how-it-works', target: '' },
            { title: 'Join as a Tech', url: '/join', target: '' },
            { title: 'Pricing', url: '/pricing', target: '' },
            { title: 'Careers', url: '/careers', target: '' },
            { title: 'Blog', url: 'https://blog.puls.com', target: '' },
            { title: 'Affiliate Program', url: '/press', target: '' }
        ]
    },
    {
        title: 'Help',
        items: [
            { title: 'FAQ', url: '/faq' }
        ]
    },
    {
        title: 'Legal',
        items: [
            { title: 'Privacy', url: '/privacy-policy', target: '' },
            { title: 'Terms', url: '/terms', target: '' },
            { title: 'Warranty', url: '/guarantee', target: '' }
        ]
    }
]
